<template>
  <div class="tab-buttons">
    <BaseTab
      v-for="(tab, index) in tabs"
      :key="index"
      :active-tab="activeTab"
      :value="tab.value"
      :text="tab.text"
      :translate-text="tab.translateText"
      :el-class="tab.elClass"
      @click="$emit('tab:click', tab.value)"
    />
  </div>
</template>
<script setup>
import BaseTab from '@/components/tabs/BaseTab.vue';

defineEmits(['tab:click']);

defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  activeTab: {
    type: String,
    default: '',
  },
});
</script>
